import { Box, Collapse, Flex, Text, ActionIcon } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'
import React from 'react'
import Icon, { ICON_SIZE } from 'components/Icon'
import { COLOR_NAMES } from 'Theme'

type FilterItemProps = {
  title: string
  children: React.ReactNode
  defaultOpened?: boolean
  onClick?: () => void
}

export const FilterCollapsibleItem = ({
  title,
  children,
  defaultOpened = false,
  onClick,
}: FilterItemProps) => {
  const [isOpened, { toggle }] = useDisclosure(defaultOpened)

  return (
    <Box
      py="20px"
      style={{
        borderTop: '1px solid',
        borderColor: COLOR_NAMES.JUPITER,
        cursor: 'pointer',

        '&:lastChild': {
          borderBottom: '1px solid',
          borderColor: COLOR_NAMES.JUPITER,
        },
      }}
      onClick={() => {
        toggle()
        onClick?.()
      }}
    >
      <Flex justify="space-between" align="center">
        <Text
          style={{ userSelect: 'none' }}
          fw={500}
          size="13px"
          tt="uppercase"
          lts="0.1em"
        >
          {title}
        </Text>
        <ActionIcon variant="subtle" size="sm">
          {isOpened ? (
            <Icon.Minus size={ICON_SIZE.PX_16} color={COLOR_NAMES.PINEY_LAKE} />
          ) : (
            <Icon.Plus size={ICON_SIZE.PX_16} color={COLOR_NAMES.PINEY_LAKE} />
          )}
        </ActionIcon>
      </Flex>

      <Collapse in={isOpened}>
        <Box mt="16px" onClick={(e) => e.stopPropagation()}>
          {children}
        </Box>
      </Collapse>
    </Box>
  )
}
